import {erpResourceApi} from "../../../../../../services/erp-resource-api.service";
import {leadSchema} from "../create-leads/schemas/create-leads.shema";
import * as messageAction from "../../../../../../store/reducers/general-ui/message.store";
import {MessageBarType} from "@fluentui/react";

export const createLeadAction = (model: any, clearFormFields: any) => {
    return async (dispatch: any) => {
        dispatch(messageAction.show({title: 'Processing.....', type: MessageBarType.info}))
        let isValid = await leadSchema.isValid(model);
        if (!isValid) {
            dispatch(messageAction.show({title: 'Invalid', type: MessageBarType.error}))

        } else {
            const {error, data} = await dispatch(erpResourceApi.endpoints.create.initiate({
                doc: 'DLAD Lead',
                payload: model
            }))

            if (error) {
                dispatch(messageAction.show({title: 'Error', type: MessageBarType.error}))
            }

            if (data) {
                dispatch(messageAction.show({title: 'Success [Created New Lead]', type: MessageBarType.success}))
                clearFormFields()
            }
        }
    }
}